import React from "react";

function FeatureLabel({ text = "Features", style = "purple" }) {
  return (
    <div className="mb-10 inline-block">
      <div className={`flex items-center rounded-lg px-4 py-2 w-max
        ${style === "purple" ? "border-[#9B29FF] border" : "bg-[#4056F3]"}
      `}>
        <img
          className="w-[10px] h-[10px] mr-2 mb-[2px]"
          src={`${style === "purple" ? require("../media/images/purple-star.svg").default : require("../media/images/star.png")}`}
          alt="star"
        />
        <span className={`font-semibold text-xs ${style === "purple" ? "text-[#9B29FF]" : "text-white"}`}>{text}</span>
      </div>
    </div>
  );
}

export default FeatureLabel;
